import React, { useState, useEffect } from 'react';
import WebhookTable from './WebhookTable';


interface WebhooksProps {
  email: string;
  loggedIn: boolean;
  token: string;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  baseUrl: string;
}

const Webhooks: React.FC<WebhooksProps> = ({ email, loggedIn, token, setLoggedIn, setEmail, baseUrl }) => {
  const [webhookData, setWebhookData] = useState<{ data: Array<{ 
    datetime: string, 
    headers: string, 
    endpoint: string, 
    body: string,
    hmacValidity: string 
  }> }>({ 
    data: [] 
  });
    const [loading, setLoading] = useState<boolean>(true); // Loading state

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await fetch(baseUrl + 'webhooks', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'jwt-token': token,
          },
        });

        const data = await response.json();
        console.log(data);

        if (data.data) {
          setWebhookData(data); // Update state with fetched data
        } else {
          console.error("Error: No items found");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchData(); // Call the fetchData function
  }, [token]); // Dependency array: re-fetch only if token changes

 

  return (
    <div className={'mainContainer'}>
      <div className={'titleContainer'}>
        <div>Webhooks</div>
      </div>
      <br />
      <div><WebhookTable webhookData={webhookData}/></div>
    </div>
  );
};

export default Webhooks;
